<!-- eslint-disable vuetify/no-deprecated-props -->
<template>
  <v-container class="ma-auto regions__container wd-p-5 xs:wd-px-0 xs:wd-py-4" fluid>
    <div
      :class="isCsBubbleShown ? 'wd-bottom-19' : 'wd-bottom-5'"
      class="regions__actions wd-fixed wd-w-full wd-z-100 wd-pointer-events-none wd-left-0"
    >
      <div class="wd-flex wd-justify-end wd-transition-all wd-px-3">
        <div class="wd-flex wd-flex-col wd-justify-end wd-gap-1">
          <v-btn
            v-show="isShowScrollTopBtn"
            class="top-page__btn wd-pointer-events-auto wd-border-1 wd-border-solid wd-border-gray50 wd-shadow-none hover:wd-shadow-none"
            min-width="52"
            width="52"
            height="52"
            color="white"
            :icon="true"
            @click="handleTopBtnClick"
          >
            <FunnowIcon class="wd-w-6 wd-h-6" max-width="24" height="24" image-path="arrow-icon__up.svg" />
          </v-btn>
          <div class="wd-relative">
            <FunkiEntryFloatingButton v-if="isShowFunkiEntry" class="wd-pointer-events-auto" />
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="regions__top d-flex align-end justify-space-between flex-wrap">
        <div class="page-header">
          <h1 class="region-title">{{ $t('region_title', { region: regionName }) }}</h1>
          <h4 v-if="regionSubTitle" class="wd-my-2 wd-text-omd wd-font-normal sm:wd-text-otempmd">{{ regionSubTitle }}</h4>
          <div v-else class="wd-h-10" />
        </div>

        <v-img
          v-if="regionCoverImage"
          class="region-feature__img"
          :src="regionCoverImage"
          :width="isMobile ? 320 : 278"
          :max-width="isMobile ? 320 : 278"
          :aspect-ratio="2.76"
          position="bottom center"
          cover
        >
          <template #placeholder>
            <v-skeleton-loader type="image" />
          </template>
        </v-img>
        <v-img
          v-else
          class="region-feature__img"
          src="@/assets/images/funnow/region-enjoy.svg?url"
          :width="isMobile ? 320 : 278"
          :max-width="isMobile ? 320 : 278"
          :aspect-ratio="2.76"
          position="bottom center"
        />
      </div>

      <client-only v-if="hasRegionInfo">
        <RegionSearchBarMobile
          v-if="isMobile"
          :all-regions="allRegions"
          :region="region"
          :categories="categoryMenuLists"
          :data-count="filterProductsCount"
          :search-params="filters"
          :search-key-word="searchKeyword"
          :search-keywords-of-region="searchKeywordsOfRegion"
          :history-key-words="historyKeyWords"
          :is-branch-card-mode="isBranchCardMode"
          @update-filter-data="updateFilterData"
          @update-search-keyword="updateSearchKeyword"
        />
        <RegionSearchBar
          v-else
          :all-regions="allRegions"
          :region="region"
          :categories="categoryMenuLists"
          :data-count="filterProductsCount"
          :search-params="filters"
          :search-key-word="searchKeyword"
          :search-keywords-of-region="searchKeywordsOfRegion"
          :history-key-words="historyKeyWords"
          :is-branch-card-mode="isBranchCardMode"
          @update-filter-data="updateFilterData"
          @update-search-keyword="updateSearchKeyword"
        />

        <template #fallback>
          <RegionSearchBarSkeleton />
        </template>
      </client-only>
      <RegionSearchBarSkeleton v-else />

      <BannersSwiper v-if="hasRegionInfo" class="page__swiper--overflow pt-3" :is-mobile="isMobile" :title="regionGreetings" :items="regionBanners" />
      <div v-else class="wd-pt-3">
        <v-skeleton-loader class="wd-py-3" width="100%" :height="isMobile ? 48 : 56" type="heading" />
        <div class="wd-flex wd-pt-1 wd-pb-3">
          <v-skeleton-loader v-if="isMobile" class="wd-mr-2" :width="320" type="card" />
          <v-skeleton-loader v-for="index in 3" v-else :key="index" class="wd-mr-5" :width="360" type="card" />
        </div>
      </div>
      <v-divider />

      <CategoriesSwiper v-if="hasRegionInfo" class="page__swiper--overflow" :is-mobile="isMobile" :region-id="regionID" :items="categories" />
      <div v-else class="d-flex flex-wrap">
        <v-skeleton-loader v-for="index in 3" :key="index" class="ma-4" width="80" height="236" type="image" />
      </div>

      <BrandSwiper
        v-if="hasRegionInfo && regionBrands.length > 0"
        class="brand__swiper"
        :is-mobile="isMobile"
        :region="region"
        :items="regionBrands"
        :title="$t('brand_title')"
      />

      <template v-if="hasRegionInfo">
        <ThemesSwiper
          class="page__swiper--overflow default__swiper mb-6"
          :is-mobile="isMobile"
          :title="$t('region_theme_title', { region: regionName })"
          :region-id="regionID || ''"
          :items="regionThemes"
        />

        <client-only>
          <div v-intersect="onIntersectFlashProducts" class="page__swiper--overflow">
            <!-- 限時優惠 -->
            <IndexProductSwiper
              v-if="regionFlashProducts.length > 4"
              :is-mobile="isMobile"
              :title="$t('region_flash_sale_title', { region: regionName })"
              :is-branch-card-mode="isBranchCardMode"
              :items="regionFlashProducts"
              :region-id="regionID || ''"
              :category-id="10782"
              :source="GtmSource.HOME_FLASH_SALES"
            />
          </div>

          <div v-intersect="onIntersectFirstCategory" class="page__swiper--overflow">
            <!-- 第一個商品列表 -->
            <IndexProductSwiper
              v-if="Boolean(topCateforiesMap[topCategoryKeys[0]])"
              :is-mobile="isMobile"
              :title="`${regionName} ${topCateforiesMap[topCategoryKeys[0]].info.name}`"
              :is-branch-card-mode="isBranchCardMode"
              :items="topCateforiesMap[topCategoryKeys[0]].products"
              :region-id="regionID || ''"
              :category-id="topCateforiesMap[topCategoryKeys[0]].info.id"
              :source="GtmSource.CATEGORY_LIST"
            />
          </div>

          <div class="information-banner__wrapper page__swiper--overflow d-flex justify-space-between">
            <v-sheet class="information-banner__sheet d-flex justify-space-between align-center flex-wrap" color="orange20">
              <div class="banner__context">
                <div class="mb-4">
                  <p class="banner__title mb-0">{{ $t('app_download_promo_card_title') }}</p>
                  <p class="banner__title mb-0">{{ downloadPromoText }}</p>
                </div>
                <v-btn class="link__btn" color="white" variant="flat" @click="downloadApp">
                  <span class="wd-text-orange50">{{ $t('all_claim_now') }}</span>
                </v-btn>
              </div>

              <v-img class="wd-w-full" src="@/assets/images/funnow/funnow-gift.svg?url" :max-width="287" />
            </v-sheet>
            <v-sheet class="information-banner__sheet d-flex justify-space-between align-center flex-wrap" color="orange50">
              <div class="banner__context">
                <p class="banner__title text-white">{{ $t('why_funnow_title') }}</p>
                <v-btn class="link__btn" color="white" variant="flat" @click="openWhyFunNow">
                  <span class="wd-text-orange50">{{ $t('why_funnow_introduction') }}</span>
                </v-btn>
              </div>

              <v-img class="wd-w-full" src="@/assets/images/funnow/why-funnow.svg?url" :max-width="268" />
            </v-sheet>
          </div>

          <div v-intersect="onIntersectSecondCategory" class="page__swiper--overflow">
            <!-- 第二個商品列表 -->
            <IndexProductSwiper
              v-if="Boolean(topCateforiesMap[topCategoryKeys[1]])"
              :is-mobile="isMobile"
              :title="`${regionName} ${topCateforiesMap[topCategoryKeys[1]].info.name}`"
              :is-branch-card-mode="isBranchCardMode"
              :items="topCateforiesMap[topCategoryKeys[1]].products"
              :region-id="regionID || ''"
              :category-id="topCateforiesMap[topCategoryKeys[1]].info.id"
              :source="GtmSource.CATEGORY_LIST"
            />
          </div>

          <NewsSwiper
            v-if="regionEventNews.length > 0"
            class="page__swiper--overflow pt-6 pb-3"
            :is-mobile="isMobile"
            :title="$t('news_event_title', { region: regionName })"
            :items="regionEventNews"
          />

          <NearCitiesSwiper
            class="page__swiper--overflow"
            :is-mobile="isMobile"
            :title="$t('nearby_cities', { region: regionName })"
            :items="otherRegions"
          />
        </client-only>
      </template>
    </div>
  </v-container>
</template>

<script>
import currencyComposition from '@/composition/currency'
import { useExternalLinks, useDownloadLinks } from '@/composition/useConst'
import { usePageView } from '@/composition/usePageView'
import { useBreakpoints } from '@/composition/useBreakpoints'
import { useFunkiStore } from '@/store-pinia/funki'

import { GtmEventMap, GtmSource } from '@/view-models/gtm'

import { getBranchList } from '@/service/branch'
import { getIsTaiwanRegion } from '@/utils/utils'
import { scrollToTop } from '@/utils/scroll'

import RegionSearchBar from '@/components/page/regions/search-bar.vue'
import RegionSearchBarMobile from '@/components/page/regions/search-bar--mobile.vue'
import RegionSearchBarSkeleton from '@/components/page/regions/RegionSearchBarSkeleton.vue'
import BannersSwiper from '@/components/swiper/banner-swiper.vue'
import CategoriesSwiper from '@/components/swiper/categories-swiper.vue'
import BrandSwiper from '@/components/swiper/brand-swiper.vue'
import ThemesSwiper from '@/components/swiper/themes-swiper.vue'

const FunkiEntryFloatingButton = defineAsyncComponent(() => import('@/components/funki/FunkiEntryFloatingButton.vue'))
const FunnowIcon = defineAsyncComponent(() => import('@/components/icons/funnow-icon.vue'))
const IndexProductSwiper = defineAsyncComponent(() => import('@/components/swiper/product-swiper__index.vue'))
const NewsSwiper = defineAsyncComponent(() => import('@/components/swiper/news-swiper.vue'))
const NearCitiesSwiper = defineAsyncComponent(() => import('@/components/swiper/near-cities-swiper.vue'))

const TOP_CATEGORY_COUNT = 2

export default defineComponent({
  name: 'RegionIndex',
  components: {
    BannersSwiper,
    CategoriesSwiper,
    BrandSwiper,
    ThemesSwiper,
    RegionSearchBar,
    RegionSearchBarMobile,
    RegionSearchBarSkeleton,
    NewsSwiper,
    IndexProductSwiper,
    NearCitiesSwiper,
    FunnowIcon,
    FunkiEntryFloatingButton,
  },
  props: {
    allRegions: { type: Array, default: () => [] },
    region: { type: Object, default: () => ({}) },
    categories: { type: Array, default: () => [] },
    searchKeywordsOfRegion: { type: Array, default: () => [] },
    historyKeyWords: { type: Array, default: () => [] },
    cardMode: { type: String, default: '' },
  },
  setup(props) {
    const { region } = toRefs(props)
    const { whyFunNowLink } = useExternalLinks()
    const { unifiedLink } = useDownloadLinks()
    const { getRegionCurrencyID, getDownloadFeedBackByRegion } = currencyComposition()
    usePageView({ event: GtmEventMap.EXPLORE_TAB_VIEWED })

    const { isMobile } = useBreakpoints()

    const { shouldShowFunkiEntry: isShowFunkiEntry } = useFunkiStore()

    const { y: windowY } = useWindowScroll()
    const isShowScrollTopBtn = computed(() => windowY.value > 20)
    const regionBrands = computed(() => region.value?.brand ?? [])

    const { isCsBubbleShown } = useCustomerService()

    function openWhyFunNow() {
      window.open(whyFunNowLink.value, '_blank')
    }

    function handleTopBtnClick() {
      scrollToTop()
    }

    return {
      getRegionCurrencyID,
      getDownloadFeedBackByRegion,
      openWhyFunNow,
      handleTopBtnClick,
      unifiedLink,
      isMobile,
      isShowFunkiEntry,
      isShowScrollTopBtn,
      isCsBubbleShown,
      regionBrands,
      GtmSource,
    }
  },
  data() {
    return {
      hasRegionInfo: !!this.region.hasOwnProperty('id') || false,
      topCategoryKeys: [],
      topCateforiesMap: {},
      regionFlashProducts: [],
      searchKeyword: '',
      filters: {},
      filterProductsCount: 0,
    }
  },
  computed: {
    regionID() {
      return this.region.id || 1
    },
    regionCoverImage() {
      return this.region.web_image ? `${this.$config.public.CDN_URI}${this.region.web_image}` : ''
    },
    regionName() {
      return this.region.name || ''
    },
    regionSubTitle() {
      return this.region.web_subtitle ? this.region.web_subtitle : ''
    },
    regionGreetings() {
      return this.region.web_greetings ? this.region.web_greetings : ''
    },
    regionBanners() {
      return this.region.banner || []
    },
    regionThemes() {
      return this.region.theme || []
    },
    regionEventNews() {
      return this.region.event_news || []
    },
    categoryMenuLists() {
      const categories = this.categories || []
      return [{ id: 0, name: this.$t('filter_category') }].concat(categories)
    },
    downloadPromoText() {
      const currencyID = this.getRegionCurrencyID(this.regionID)
      const isTaiwanRegion = getIsTaiwanRegion(this.regionID)
      const amount = this.getDownloadFeedBackByRegion(currencyID)
      return isTaiwanRegion ? this.$t('app_download_promo_card_content_movie', { amount }) : this.$t('app_download_promo_card_content', { amount })
    },
    otherRegions() {
      if (this.allRegions.length > 1) {
        return this.allRegions.filter(region => {
          return region.region_id !== this.regionID
        })
      }
      return []
    },
    isBranchCardMode() {
      return this.cardMode === 'branch'
    },
  },
  watch: {
    region(newRegion) {
      if (!this.hasRegionInfo && newRegion.hasOwnProperty('id')) {
        this.initRegionIndex()
        this.hasRegionInfo = true
      } else {
        this.initRegionIndex()
      }
    },
  },
  created() {
    if (this.hasRegionInfo) {
      this.initRegionIndex()
    }
  },
  methods: {
    initRegionIndex() {
      this.initTopCategories()
      this.initSearchInfo()
    },
    initSearchInfo() {
      if (this.isBranchCardMode) {
        getBranchList(this.$axios, { filter_regionid: this.regionID }).then(res => {
          if (res.code === 0) {
            this.filterProductsCount = res.total_count || 0
          }
        })
        return
      }

      this.$axios.$get(`/pub/product`, { params: { filter_regionid: this.regionID } }).then(res => {
        if (res.code === 0) {
          this.filterProductsCount = res.total_count || 0
        }
      })
    },
    initTopCategories() {
      for (let index = 0; index < TOP_CATEGORY_COUNT; index++) {
        const categoryInfo = this.categories[index]
        if (categoryInfo) {
          this.topCategoryKeys.splice(index, 0, categoryInfo.id)
          this.topCateforiesMap[categoryInfo.id] = { info: categoryInfo, products: [] }
        }
      }
    },
    getCategoryProducts(categoryID) {
      if (categoryID) {
        const filterData = { filter_regionid: this.regionID, category_id: categoryID }

        if (this.isBranchCardMode) {
          getBranchList(this.$axios, { ...filterData })
            .then(res => {
              if (res.code === 0) {
                if (res.data.length > 0) {
                  const categoryMap = {}
                  categoryMap[categoryID] = this.topCateforiesMap[categoryID]
                  categoryMap[categoryID].products = res.data || []
                  this.topCateforiesMap = Object.assign({}, this.topCateforiesMap, categoryMap)
                }
              } else {
                throw res
              }
            })
            .catch(error => {
              console.error('getCategoryBranches: error', error)
            })

          return
        }

        this.$store
          .dispatch('product/getProductList', filterData)
          .then(res => {
            if (res.code === 0) {
              if (res.data.length > 0) {
                const categoryMap = {}
                categoryMap[categoryID] = this.topCateforiesMap[categoryID]
                categoryMap[categoryID].products = res.data || []
                this.topCateforiesMap = Object.assign({}, this.topCateforiesMap, categoryMap)
              }
            } else {
              throw res
            }
          })
          .catch(error => {
            console.error('getCategoryProducts: error', error)
          })
      }
    },
    updateFilterData({ totalCount, filters }) {
      this.filters = Object.assign({}, filters)
      this.filterProductsCount = totalCount
    },
    updateSearchKeyword(keyword) {
      this.searchKeyword = keyword
    },
    downloadApp() {
      window.open(this.unifiedLink, '_blank')
    },
    getFlashProductsOfRegion() {
      if (this.isBranchCardMode) {
        const flashParams = {
          start: 0,
          sortby: 'popular',
          filter_regionid: this.regionID,
          categoryId: 10782,
        }

        getBranchList(this.$axios, { ...flashParams })
          .then(res => {
            if (res.code === 0) {
              this.regionFlashProducts = [].concat(res.data)
            } else {
              throw res
            }
          })
          .catch(error => {
            console.error('getFlashBranchesOfRegion: error', error)
          })

        return
      }

      this.$store
        .dispatch('product/getFlashProductList', { regionID: this.regionID })
        .then(res => {
          if (res.code === 0) {
            this.regionFlashProducts = [].concat(res.data)
          } else {
            throw res
          }
        })
        .catch(error => {
          console.error('getFlashProductsOfRegion: error', error)
        })
    },
    onIntersectFlashProducts(isIntersecting, entries, observer) {
      if (isIntersecting) {
        this.getFlashProductsOfRegion()
      }
    },
    doGetProductsOfCategory(categoryID) {
      const hasProducts = this.topCateforiesMap[categoryID].products.length > 0
      if (!hasProducts) {
        this.getCategoryProducts(categoryID)
      }
    },
    onIntersectFirstCategory(isIntersecting, entries, observer) {
      const categoryID = this.topCategoryKeys[0]
      if (isIntersecting && categoryID) {
        this.doGetProductsOfCategory(categoryID)
      }
    },
    onIntersectSecondCategory(isIntersecting, entries, observer) {
      const categoryID = this.topCategoryKeys[1]
      if (isIntersecting && categoryID) {
        this.doGetProductsOfCategory(categoryID)
      }
    },
  },
})
</script>

<style scoped lang="scss" src="@/assets/sass/pages/region-index.scss"></style>
<style scoped lang="scss">
@use '@/assets/sass/modules/_mixins.scss' as *;

:deep(.v-skeleton-loader) {
  .v-skeleton-loader__heading {
    margin: 0;
  }
  .v-skeleton-loader__card {
    .v-skeleton-loader__image {
      height: 135px;
    }
    @include xxs {
      .v-skeleton-loader__image {
        height: 120px;
      }
    }
    .v-skeleton-loader__heading {
      height: 44px;
    }
  }
}
</style>
